import { FC, useEffect, useRef } from 'react';

import BoxIcon from '../IconsSvg/BoxIcon';
import LabelIcon from '../IconsSvg/LabelIcon';
import LockIcon from '../IconsSvg/LockIcon';

import { CustomerList } from '../../utils/models/account';

const TipsCardsComponent: FC = () => {
    const commonTranslations = document.querySelector('#translationsObject')
        ? JSON.parse(document.querySelector('#translationsObject')!.innerHTML)
        : null;
    const loginToQuoteHtml = useRef(null);
    const signUpToBuyHtml = useRef(null);
    const currentUser: CustomerList | null = localStorage.getItem('br_currentUser')
        ? JSON.parse(localStorage.getItem('br_currentUser') as string)
        : null;

    useEffect(() => {
        if (loginToQuoteHtml && loginToQuoteHtml.current) {
            (loginToQuoteHtml.current as any).innerHTML = commonTranslations.login_to_quote_html ?? '';
        }
        if (signUpToBuyHtml && signUpToBuyHtml.current) {
            (signUpToBuyHtml.current as any).innerHTML = commonTranslations.sign_up_to_buy_html ?? '';
        }
    }, [loginToQuoteHtml, signUpToBuyHtml]);

    return (
        <div className="br-iconWithText__information">
            {currentUser || window.berardi_accountUserData.accountCode ? (
                <div className="br-iconWithText__item">
                    <BoxIcon />
                    <div className="br-iconWithText__content">
                        <p className="br-iconWithText__title">{commonTranslations.want_to_quote ?? ''}</p>
                        <p className="br-iconWithText__text">{commonTranslations.in_the_cart ?? ''}</p>
                    </div>
                </div>
            ) : (
                <div className="br-iconWithText__details">
                    <div className="br-iconWithText__item">
                        <LabelIcon />
                        <div className="br-iconWithText__content">
                            <p className="br-iconWithText__title">{commonTranslations.login_to_see_prices ?? ''}</p>
                            <p className="br-iconWithText__text" ref={loginToQuoteHtml} />
                        </div>
                    </div>
                    <div className="br-iconWithText__item">
                        <LockIcon />
                        <div className="br-iconWithText__content">
                            <p className="br-iconWithText__title">{commonTranslations.want_to_be_customer ?? ''}</p>
                            <p className="br-iconWithText__text" ref={signUpToBuyHtml} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TipsCardsComponent;
